import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export type EntityStatusType = 'CUSTOMER' | 'DRIVER' | 'VEHICLE' | 'BROKER' | 'COMPANY' | 'FREIGHT_FORWARDER' | 'AGENCY';

@Injectable({
    providedIn: 'root'
})
export class EntityStatusService {
    private baseUrl = `${environment.restApiUrl}v1/status`;

    constructor(private http: HttpClient) { }

    getStatus(type: EntityStatusType, id: number) {
        return this.http.get(`${this.baseUrl}/${type}/${id}`, { responseType: 'text' });
    }

    setStatus(type: EntityStatusType, id: number, status: string, reason?: string) {
        const params: Record<string, string> = { status };
        if (reason) {
            params['reason'] = reason;
        }
        return this.http.post<void>(`${this.baseUrl}/${type}/${id}`, null, { params });
    }
}
